import { pb } from '../../../shared/api/pocketbase';
import type { FetchOptionsResult, SelectOption } from '../../../shared/ui/Select';
import type { Partner } from './types';

export const fetchPartnersByIds = async (ids: string[]): Promise<SelectOption[]> => {
  if (!ids.length) return [];
  const filter = ids.map(id => `id = "${id.replace(/"/g, '')}"`).join(' || ');
  const result = await pb.collection('partners').getFullList<Partner>({ filter, fields: 'id,name', requestKey: null });
  return result.map(p => ({ value: p.id, label: p.name }));
};

export const fetchPartnersOptions = async ({ page, search }: { page: number; search: string }): Promise<FetchOptionsResult> => {
  const perPage = 20;
  const safeSearch = search.replace(/"/g, '');
  const filter = safeSearch
    ? `name ~ "${safeSearch}" && isBlocked = false`
    : 'isBlocked = false';
  const result = await pb.collection('partners').getList<Partner>(page, perPage, {
    sort: 'name',
    filter,
    fields: 'id,name',
    requestKey: null,
  });
  return {
    items: result.items.map(p => ({ value: p.id, label: p.name })),
    hasMore: page * perPage < result.totalItems,
  };
};
